import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const AdvancedPro: IFeatureMap = {
  data: {
    includedKnownPeople: 50000,
    // 200x Known People
    includedAnonymousPeople: 200 * 50000,
    // 200k Known People actions (monthly)
    trackedActivities: 200000,
    // 20k Known People (monthly)
    emailsSent: 20000,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 200,
    conversionPixels: 100,
    implementationsPageVisible: true,
    zapier: Infinity,
    directIntegrations: Infinity,
    iMISDirectIntegration: true,
    blackbaudDirectIntegration: true,
  },
  ads: {
    [retargeting]: true,
    [mobileGeoFencing]: 10,
    [mobileGeoFenceRetargeting]: 10,
    [facebook]: true,
    [emailListFacebook]: true,
    [emailList]: 10,
    [search]: true,
    [seedSegment]: true,
    [affinity]: true,
    [googleAdsSmart]: true,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: true,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    domainsAuthenticated: Infinity,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    // 50/month
    adBannerCreator: 50,
  },
  invites: {
    [invites]: true,
    partnerManager: true,
    partnersPerProject: 250,
    partnerMarketingCollateralBuilder: true,
    partnerDashboards: 250,
  },
  monetization: {
    sponsoredRetargetingCampaigns: true,
    liveSponsorReports: true,
  },
  other: {
    flights: true,
    forms: true,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: 'cost-per-ip',
    users: 25,
    childAccountsWithSwitcher: 10,
    childAccountSharingWithPermissionManagement: Infinity,
    // TODO: ask freddy if this needs to change to true based on .isPlatformAdvanced
    customUserRolesAndPermissionsManagement: false,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    // 3 hours/month
    dedicatedStrategicAdvisorHours: 3,
    livePhoneSupport: true,
    dataIntegrationServicesActiveWithLicense: true,
    proResourcesPageVisible: true,
  },
};
